import { useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TypedBackendQueryKey } from "hooks";
import type { Appointment } from "models";

export const getAppointmentForSnooze = async (queryKey: TypedBackendQueryKey<Appointment>, id: number): Promise<Appointment> => {
  const { baseUrl, endpoint, params } = queryKey;
  const res = await ApiInstance.post(endpoint, { ...params, id }, baseUrl);

  return res.data;
};

export const useAppointmentForSnoozeQuery = (id: number) => {
  const { data, isFetching, error } = useTypedQuery({
    queryKey: AppointmentDetailsKeys.snoozeAppointment,
    queryFn: (queryKey: TypedBackendQueryKey<Appointment>) => getAppointmentForSnooze(queryKey, id)
  });

  return { appointment: data, loading: isFetching, error: error };
};
